var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2259,
    height: 2249,
    viewBox: "0 0 2259 2249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_2461_4981)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1030.71,
    y: 405,
    width: 1127.45,
    height: 914.941,
    rx: 457.471,
    transform: "rotate(43.1471 1030.71 405)",
    fill: "url(#paint0_linear_2461_4981)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2461_4981",
    x: 0.152344,
    y: 0.150391,
    width: 2257.99,
    height: 2248.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 297,
    result: "effect1_foregroundBlur_2461_4981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2461_4981",
    x1: 1187.15,
    y1: 877.967,
    x2: 2063.89,
    y2: 933.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#086E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749983,
    stopColor: "#C0C0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6475D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgColor);
export default __webpack_public_path__ + "static/media/bg-color.2cab7c6b138d75a0f45846dcbf48f8fd.svg";
export { ForwardRef as ReactComponent };